import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';
import { handleRipple } from '../../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  ImageSection,
  Image,
  ContentSection,
  Title,
  Text,
  Button,
  Orangecircle,
} from './styled';

const Earn = () => {
  const { formatMessage } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageSection>
          <Image
            src={formatMessage({ id: 'home.spendrewards.earnmore.image.src' })}
            alt={formatMessage({ id: 'home.spendrewards.earnmore.image.alt' })}
            loading="lazy"
          />
        </ImageSection>
        <ContentSection>
          <Title>
            <FormattedMessage id="home.spendrewards.earnmore.title" />
          </Title>
          <Text>
            <FormattedMessage id="home.spendrewards.earnmore.text" />
          </Text>
          <Button
            href={formatMessage({
              id: 'home.spendrewards.earnmore.buttonLink',
            })}
            target="_blank"
            onMouseEnter={handleRipple}
          >
            <FormattedMessage id="home.spendrewards.earnmore.buttonText" />
            <Orangecircle
              src="/images/uploads/orange-icon.svg"
              alt="Orange Icon"
            />
          </Button>
        </ContentSection>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const earnAndGrowFragment = graphql`
  fragment Earn on Json {
    spendrewards {
      earnmore {
        image {
          src
          alt
        }
        title
        text
        buttonText
        buttonLink
      }
    }
  }
`;

export default Earn;
